<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <add-host></add-host>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Hosts</h5>
        <button class="btn btn-xs btn-primary pull-right"  data-toggle="modal" data-target="#add-host">Add Hosting Account</button>
      </div>
      <div class="ibox-content col-lg-12">
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import HostList from './Hosts/List'
import AddHostModal from './Hosts/AddHostModal'

export default {
  components: {
    list: HostList,
    addHost: AddHostModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Hosts.vue